<form [formGroup]="form">
    <div class="row mt-3">
        <div class="col-md-6">
            <label class="form-label">DATE RANGE</label>
            <ejs-daterangepicker
                [startDate]="form.get('fromDateFilter')?.value"
                [endDate]="form.get('toDateFilter')?.value"
                [placeholder]="'Select Date Range'"
                [showClearButton]="true"
                [format]="'dd/MMM/yyyy'"
                (change)="onRangeChange($event)">
                <e-presets>
                    <e-preset
                        label="Today"
                        [start]="presetRanges.todayStart"
                        [end]="presetRanges.todayEnd"></e-preset>
                    <e-preset
                        label="Yesterday"
                        [start]="presetRanges.yesterdayStart"
                        [end]="presetRanges.yesterdayEnd"></e-preset>
                    <e-preset
                        label="This Week"
                        [start]="presetRanges.weekStart"
                        [end]="presetRanges.weekEnd"></e-preset>
                    <e-preset
                        label="Last Week"
                        [start]="presetRanges.lastWeekStart"
                        [end]="presetRanges.lastWeekEnd"></e-preset>
                    <e-preset
                        label="This Month"
                        [start]="presetRanges.monthStart"
                        [end]="presetRanges.monthEnd"></e-preset>
                    <e-preset
                        label="Last Month"
                        [start]="presetRanges.lastMonthStart"
                        [end]="presetRanges.lastMonthEnd"></e-preset>
                    <e-preset
                        label="This Year"
                        [start]="presetRanges.yearStart"
                        [end]="presetRanges.yearEnd"></e-preset>
                    <e-preset
                        label="Last Year"
                        [start]="presetRanges.lastYearStart"
                        [end]="presetRanges.lastYearEnd"></e-preset>
                </e-presets>
            </ejs-daterangepicker>
        </div>

        <div class="col-md-6">
            <label class="form-label"></label>
            <div>
                <a class="advanced-search" (click)="toggle.emit()">
                    <u><img class="mr-2" src="assets/images/dropdown.png" />ADVANCED SEARCH</u>
                </a>
                <a class="clear-filters" (click)="clear.emit()"><u>CLEAR FILTERS</u></a>
            </div>
        </div>
    </div>

    @if (showAdvancedFilters) {
        <hr />

        <div class="search-form">
            <div class="row">
                <div class="col-md-4">
                    <label class="form-label">PROVINCES</label>
                    <ng-select
                        [items]="filters.provinces"
                        bindLabel="name"
                        placeholder="Select Provinces"
                        multiple="true"
                        [formControlName]="provinceFieldKey"
                        bindValue="id"
                        (change)="emitChange($event, provinceFieldKey)"
                        (clear)="emitClear(provinceFieldKey)">
                    </ng-select>
                </div>
                <div class="col-md-4">
                    <label class="form-label">PRODUCTS</label>
                    <ng-select
                        [items]="filters.products"
                        bindLabel="groupTitle"
                        placeholder="Select Products"
                        multiple="true"
                        [searchable]="true"
                        [formControlName]="productFieldKey"
                        bindValue="groupCode"
                        (change)="emitChange($event, productFieldKey)"
                        (clear)="emitClear(productFieldKey)">
                    </ng-select>
                </div>
                <div class="col-md-4">
                    <label class="form-label">WHOLESALERS</label>
                    <ng-container
                        *ngIf="
                            form.get(provinceFieldKey)?.value &&
                                form.get(provinceFieldKey)?.value.length > 0;
                            else noProvinceSelected
                        ">
                        <ng-select
                            [items]="filters.wholesalers"
                            bindLabel="name"
                            placeholder="Select Wholesalers"
                            multiple="true"
                            [formControlName]="wholesalerFieldKey"
                            bindValue="id"
                            (change)="emitChange($event, wholesalerFieldKey)"
                            (clear)="emitClear(wholesalerFieldKey)">
                        </ng-select>
                    </ng-container>
                    <ng-template #noProvinceSelected>
                        <div class="form-control readonly-placeholder">
                            Please select a province first.
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>

        <div class="searched-items">
            <div *ngFor="let key of searchItems | keyvalue">
                <div *ngIf="key.value?.length > 0">
                    <div *ngFor="let item of key.value" class="search-item-value">
                        {{ item | humanize }}
                        <a (click)="removeSearch(key.key, item)">
                            <img src="assets/images/close-x-white.png" />
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="search-form">
            <div class="row">
                <div class="col-md-4">
                    <label class="form-label">STORES</label>
                    <ng-container
                        *ngIf="
                            form.get(provinceFieldKey)?.value &&
                                form.get(provinceFieldKey)?.value.length > 0;
                            else noProvinceSelectedForStore
                        ">
                        <ng-select
                            [items]="filters.stores"
                            bindLabel="name"
                            placeholder="Select Stores"
                            multiple="true"
                            [formControlName]="storeFieldKey"
                            bindValue="id"
                            (change)="emitChange($event, storeFieldKey)"
                            (clear)="emitClear(storeFieldKey)">
                        </ng-select>
                    </ng-container>
                    <ng-template #noProvinceSelectedForStore>
                        <div class="form-control readonly-placeholder">
                            Please select a province first.
                        </div>
                    </ng-template>
                </div>

                @if ((sessionUser$ | async)?.isAdmin()) {
                    <div class="col-md-4">
                        <label class="form-label">BUSINESS UNIT</label>
                        <ng-select
                            [items]="filters.supplierBusinessUnits"
                            bindLabel="name"
                            placeholder="Select Business Units"
                            multiple="true"
                            [formControlName]="businessFieldKey"
                            bindValue="id"
                            (change)="emitChange($event, businessFieldKey)"
                            (clear)="emitClear(businessFieldKey)">
                        </ng-select>
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">SUPPLIERS</label>
                        <ng-select
                            [items]="filters.suppliers"
                            bindLabel="name"
                            placeholder="Select Suppliers"
                            multiple="true"
                            [formControlName]="supplierFieldKey"
                            bindValue="id"
                            (change)="emitChange($event, supplierFieldKey)"
                            (clear)="emitClear(supplierFieldKey)">
                        </ng-select>
                    </div>
                }
            </div>
        </div>

        @if (categoryFieldKey) {
            <div class="search-form">
                <div class="row">
                    <div class="col-md-4">
                        <label class="form-label">CATEGORY</label>
                        <ng-select
                            [items]="filters.categories"
                            bindLabel="name"
                            placeholder="Select Categories"
                            multiple="true"
                            [formControlName]="categoryFieldKey"
                            bindValue="id"
                            (change)="emitChange($event, categoryFieldKey)"
                            (clear)="emitClear(categoryFieldKey)">
                        </ng-select>
                    </div>
                </div>
            </div>
        }
    }
</form>
